module.exports = __webpack_public_path__ + "static/img/bg_01.727aa5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_01.png
// module id = Ydyk
// module chunks = 3